import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Dropdown } from 'primereact/dropdown';
import FieldCombo from '../combos/FieldCombo';
import FaDate from '../shared/FaDate';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import ColorCombo from '../combos/ColorCombo';
import ShowVideo from '../shared/ShowVideo';


export default function AnnounceSimple(props) {
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [title, setTitle] = useState("");
    const [text,setText] = useState("");
    const [startDate, setStartDate] = useState(0);
    const [endDate, setEndDate] = useState(0);
    const [includeTeacher, setIncludeTeacher] = useState(true);
    const [includeStudent, setIncludeStudent] = useState(true);
    const [includeParent, setIncludeParent] = useState(true);
    const [color, setColor] = useState("");
    const [newStartDate, setNewStartDate] = useState(0);
    const [newEndDate, setNewEndDate] = useState(0);


    useEffect(() => {
      loadItems();
    }, []);
    const loadItems = function(){
      setLoading(true);
      
      var params = {login:util.getTrustedUser(), searchText:"", lastIndex:0, pageSize:0};
      var url = config.Server+`/school/announce-simple/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }
    const addNewItem = function(){
      setCurrentItem(null);
      setTitle("");
      setText("");
      setStartDate(0);
      setEndDate(0);
      setIncludeTeacher(true);
      setIncludeStudent(true);
      setIncludeParent(true);
      setColor("#d9e2f3");
      setEditFormVisible(true);
    }
    const onRowEditClick = function(row) {
      setTitle(row.title);
      setText(row.text);
      setStartDate(row.startDate);
      setEndDate(row.endDate);
      setNewStartDate(row.startDate);
      setNewEndDate(row.endDate);
      setIncludeTeacher(row.includeTeacher);
      setIncludeStudent(row.includeStudent);
      setIncludeParent(row.includeParent);
      setColor(row.color);
      setCurrentItem(row);
      setEditFormVisible(true);        
    }
    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }

    const closeEditDialog = function(){
      setEditFormVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/school/announce-simple/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const checkDataEntry = function(){
        if(title.trim().length == 0){
            setErrorMessage("موضوع را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(text.trim().length == 0){
            setErrorMessage("متن اطلاعیه را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(newStartDate<=0){
          setErorVisible(true);
          setErrorMessage("تاریخ شروع نمایش اطلاعیه را مشخص نمائید");
          return false;
        }
        if(newEndDate<=0){
          setErorVisible(true);
          setErrorMessage("تاریخ پایان نمایش اطلاعیه را مشخص نمائید");
          return false;
        }
        if((color == "")||(color == null)){
            setErrorMessage("نوع رنگ را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;
      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var params = {login:util.getTrustedUser(), id:id, title:title, text:text, startDate:newStartDate, endDate:newEndDate, includeTeacher:includeTeacher, includeStudent:includeStudent, includeParent:includeParent, color:color};
      var url = config.Server+`/school/announce-simple/save`;
      console.log("course is >", params);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {...response}
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    }
    const onInputChange = function(e, fname){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(fname === "title") setTitle(val);
        else if(fname === "text") setText(val);
        
    }
    const onComboChange = function(fname, e){
        if(fname === "color") {
          setColor(e);
          console.log("s c t>", e)
        }
    }
    
    const setRowActions = function(row) {
      return(
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
      )
    }
    
    return(      
      <> 
      <ShowVideo videoId="announce" top={65} md={6} />  
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>لیست اطلاعیه ها</div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>          
        {
          loading?
                  <DataTable value={LoadingRows}  className="p-datatable-striped">
                      <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                      <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                  </DataTable>
          :
            <>
            <Row style={{}}>
              <Col md={2}>
                <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                  <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                </div>                
              </Col>
            </Row>
              
            <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
              paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown "
              currentPageReportTemplate="{first} تا {last} از {totalRecords}"
              dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                      <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                      <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                      {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                      <Column field="title" header={"موضوع"} sortable className="list-cell-text-align"></Column>
                      <Column field="startDate" body={(row) => util.SeperateDate(row.startDate)} header={"تاریخ شروع"} sortable className="list-cell-text-align"></Column>
                      <Column field="endDate" body={(row) => util.SeperateDate(row.endDate)} header={"تاریخ پایان"} sortable className="list-cell-text-align"></Column>
                      <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
              </DataTable>
            </>
        }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت مشخصات اطلاعیه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={title} onChange={(e)=>{onInputChange(e, "title")}} id="title" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"rtl"}} />
                                  <label htmlFor="title">موضوع</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              متن اطلاعیه:
                              <br></br>
                              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setText(e.target.value)}} value={text} />
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td>
                                <div className="flex align-items-center" style={{marginTop:"5px", float:"right", height:"30px", overflow:"hidden"}}>
                                    <Checkbox inputId={"chkincludeTeacher"} onChange={(e)=>{setIncludeTeacher(e.checked)}}  checked={includeTeacher} />
                                    <label htmlFor={"chkincludeTeacher"} className="ml-2"> &nbsp;همکاران مشاهده کنند</label>
                                </div>
                            </td>
                          </tr>                         
                          <tr>
                            <td>
                                <div className="flex align-items-center" style={{marginTop:"5px", float:"right", height:"30px", overflow:"hidden"}}>
                                    <Checkbox inputId={"chkincludeStudent"} onChange={(e)=>{setIncludeStudent(e.checked)}}  checked={includeStudent} />
                                    <label htmlFor={"chkincludeStudent"} className="ml-2"> &nbsp;دانش آموزان مشاهده کنند</label>
                                </div>
                            </td>
                          </tr>                         
                          <tr>
                            <td>
                                <div className="flex align-items-center" style={{marginTop:"5px", float:"right", height:"30px", overflow:"hidden"}}>
                                    <Checkbox inputId={"chkincludeParent"} onChange={(e)=>{setIncludeParent(e.checked)}}  checked={includeParent} />
                                    <label htmlFor={"chkincludeParent"} className="ml-2"> &nbsp;اولیای دانش آموزان مشاهده کنند</label>
                                </div>
                            </td>
                          </tr>                         
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              شروع نمایش از تاریخ:
                              <br/>
                              <FaDate value={startDate} onChange={(val)=>setNewStartDate(val)} />
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              پایان نمایش در تاریخ:
                              <br/>
                              <FaDate value={endDate} onChange={(val)=>setNewEndDate(val)} />
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <ColorCombo value={color} onChange={(e)=>{onComboChange("color", e)}} />
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>

                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
